<template>
  <div class="impressum-container">
    <h1>Impressum</h1>
    
    <p>Facetronic UG (haftungsbeschränkt)<br>
    Im Zukunftspark 4<br>
    74076 Heilbronn<br>
    Deutschland</p>

    <p>Telefon: +49 7131 3859900<br>
    E-Mail: <a href="mailto:info@facetronic.de">info@facetronic.de</a></p>

    <h2>Vertreten durch die Geschäftsführer</h2>
    <p>Anton Dieterich<br>
    Phil Ehrmann</p>

    <h2>Eingetragen im Handelsregister</h2>
    <p>Amtsgericht Stuttgart<br>
    HRB 796029</p>

    <h2>Umsatzsteuer-ID</h2>
    <p>Umsatzsteuer-Identifikationsnummer:<br>
    DE370183823</p>

    <h2>Verbraucherstreitbeteiligung</h2>
    <p>Wir sind weder bereit noch verpflichtet, an Streitbeteiligungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

    <h2>Redaktionell verantwortlich</h2>
    <p>Phil Ehrmann<br>
    Im Zukunftspark 4<br>
    74076 Heilbronn</p>

    <h2>Social-Media-Präsenzen</h2>
    <p>Dieses Impressum gilt auch für folgende Social-Media-Präsenzen:</p>
    <ul>
      <li>Instagram: <a href="https://instagram.com/facetronicde" target="_blank" rel="noopener">https://instagram.com/facetronicde</a></li>
      <li>LinkedIn: <a href="https://linkedin.com/company/facetronic" target="_blank" rel="noopener">https://linkedin.com/company/facetronic</a></li>
    </ul>

    <p class="stand">Stand: 02. Februar 2026</p>
  </div>
</template>

<script>
export default {
  name: 'ImpressumView'
}
</script>

<style scoped>
.impressum-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 80px;
}

h1 {
  color: var(--color-secondary);
  margin-bottom: 2rem;
}

h2 {
  color: var(--color-secondary);
  margin-bottom: 1rem;
}

p {
  line-height: 1.6;
  color: var(--color-text);
  margin-bottom: 2rem;
}

a {
  color: var(--color-primary);
  text-decoration: underline;
}

a:hover {
  color: var(--color-primary-dark);
}

ul {
  list-style: disc;
  padding-left: 1.5rem;
  margin-bottom: 2rem;
  line-height: 1.8;
  color: var(--color-text);
}

.stand {
  margin-top: 2rem;
  font-style: italic;
  color: var(--color-text-muted);
}
</style> 